import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["bottomSheet", "backdrop", "sheet"]
  static values = {
    courseUuid: String,
    lessonId: Number
  }

  showWhyThisVideo() {
    const bottomSheet = this.bottomSheetTarget
    const backdrop = this.backdropTarget
    const sheet = this.sheetTarget

    // Enable pointer events
    bottomSheet.classList.remove("pointer-events-none")

    // Trigger animation on next frame
    requestAnimationFrame(() => {
      backdrop.classList.remove("opacity-0")
      backdrop.classList.add("opacity-50", "pointer-events-auto")
      sheet.classList.remove("translate-y-full")
      sheet.classList.add("translate-y-0")
    })

    // Prevent body scroll when bottom sheet is open
    document.body.style.overflow = "hidden"
  }

  hideWhyThisVideo() {
    const bottomSheet = this.bottomSheetTarget
    const backdrop = this.backdropTarget
    const sheet = this.sheetTarget

    // Trigger hide animation
    backdrop.classList.remove("opacity-50", "pointer-events-auto")
    backdrop.classList.add("opacity-0")
    sheet.classList.remove("translate-y-0")
    sheet.classList.add("translate-y-full")

    // Wait for animation to complete before hiding
    setTimeout(() => {
      bottomSheet.classList.add("pointer-events-none")
    }, 300)

    // Restore body scroll
    document.body.style.overflow = ""
  }

  async markAsComplete() {
    try {
      // Mark the current lesson as complete
      const url = `/courses/${this.courseUuidValue}/lessons/${this.lessonIdValue}/complete`
      const response = await post(url, {
        responseKind: 'json'
      })

      if (response.ok) {
        // Show the completion interstitial modal
        const interstitialModal = document.querySelector('[data-controller="lesson-interstitial"]')
        if (interstitialModal) {
          // Get the Stimulus controller instance and call show() method
          const stimulus = window.Stimulus || this.application
          const interstitialController = stimulus.getControllerForElementAndIdentifier(
            interstitialModal,
            'lesson-interstitial'
          )

          if (interstitialController) {
            interstitialController.show()
          } else {
            // Fallback if controller not found
            interstitialModal.classList.remove('hidden')
            document.body.style.overflow = 'hidden'
          }
        } else {
          // If no next lesson, just reload to show completed state
          window.location.reload()
        }
      } else {
        console.error('Failed to mark lesson as complete')
      }
    } catch (error) {
      console.error('Error completing lesson:', error)
    }
  }
}
